import { useEffect } from "react";
import { useApp } from "../../../context/AppContextProvider";
import i18n from "../../../language/i18n";
import { NotificationManager } from "../../../notifications/NotificationManager";
import { useAuth } from "../../../context/UserContextProvider";
import ErrorLayout from "../../../components/common/error/ErrorLayout";

const TokenErrorScreen = () => {
  const { setBoarding, isFullScreen, setIsFullScreen } = useApp();
  const { handleStateLogout } = useAuth();

  useEffect(() => {
    if (isFullScreen === false) {
      setIsFullScreen(true);
    }
  }, []);

  const handleClickToNavigate = async () => {
    window.location.href = "/";
    handleStateLogout();
    setBoarding("LANDING");
    NotificationManager.success(i18n.t("logout_successful_text"));
  };

  return (
    <ErrorLayout
      statusCode={"401"}
      statusText={i18n.t("token_error_status_text")}
      helpText={i18n.t("token_error_help_text")}
      tone="warning"
      icon="clock"
      actionTitle={i18n.t("login")}
      onAction={handleClickToNavigate}
    />
  );
};

export default TokenErrorScreen;
